import React from 'react';
import { Modal } from 'react-bootstrap';
import { Spinner } from 'hyperdb-utils';
import GroupForm from '../../propertyGroup/components/Form';
import api from 'api';

class ModalCreateGroup extends React.Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  componentDidMount() {
    this.props.api.propertyGroup.initCreateForm();
  }
  componentWillReceiveProps(nextProps) {
    const { submitSuccessful, savedObject } = this.props.api.getState('propertyGroup');
    if (submitSuccessful) {
      this.props.onGroupCreated(savedObject.id);
    }
  }
  render() {
    const { formLoaded, objectData, loading } = this.props.api.getState('propertyGroup');
    return (
      <Modal show={ true } onHide={ this.props.onClose } backdrop="static" keyboard={ false }>
        <Modal.Header closeButton>
          <Modal.Title>Create group</Modal.Title>
        </Modal.Header>
        <Modal.Body className="box">
          <Spinner show={ loading } />
          { formLoaded ? <GroupForm api={ this.props.api } objectData={ objectData } /> : null }
        </Modal.Body>
        <Modal.Footer>
          <button onClick={ this.props.onClose } type="button" className="btn btn-sm btn-default">Cancel</button>
          <button onClick={ this.handleSubmit } disabled={ loading } type="button" className="btn btn-sm btn-success">Create</button>
        </Modal.Footer>
      </Modal>
    );
  }
  handleSubmit() {
    const propertyGroup = this.props.api.getState('propertyGroup').objectData;
    this.props.api.propertyGroup.submitCreateForm(propertyGroup);
  }
}

ModalCreateGroup.propTypes = {
  api: React.PropTypes.object,
  onClose: React.PropTypes.func,
  onGroupCreated: React.PropTypes.func,
};

export default api.connect(ModalCreateGroup);



// WEBPACK FOOTER //
// ./src/frontend/modules/inventory/property/components/ModalCreateGroup.jsx